import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import { noop } from 'Helpers/PropTypes';
import DraftsOutlinedIcon from '@material-ui/icons/DraftsOutlined';
import MailIcon from '@material-ui/icons/Mail';
import ToggleAttributeButton from 'Components/ComponentLibrary/Molecules/ToggleAttributeButton/ToggleAttributeButton';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('ToggleUnreadButton', () => ({
  root: {},
  fullWidth: {
    width: '100%',
    justifyContent: 'left',
  },
}));

const ToggleUnreadButton = ({
  className,
  onChange, // This is onChange because MetaControl passes in an on change for a toggleable field
  value: isUnread,
  color,
  size,
  fullWidth,
  showLabel,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const buttonToolTipText = isUnread ? 'Mark Read' : 'Mark Unread';

  return (
    <Tooltip
      title={buttonToolTipText}
      placement="top"
    >
      {/* The box is only here because Tooltip doesn't work without it due to the button having its own hover events */}
      {/* See: https://stackoverflow.com/questions/48930334/mui-next-tooltip-does-not-show-on-hover */}
      <Box className={classNames(className, classes.root)}>
        <ToggleAttributeButton
          className={classNames({
            [classes.fullWidth]: fullWidth,
          })}
          value={isUnread}
          icon={MailIcon}
          secondaryIcon={DraftsOutlinedIcon}
          onChange={onChange}
          color={color}
          size={size}
          label={showLabel ? buttonToolTipText : null}
          dataTestKeys={DataValueMap.init('toggle-unread-button').build()}
        />
      </Box>
    </Tooltip>
  );
};

ToggleUnreadButton.defaultProps = {
  className: '',
  onChange: noop,
  color: 'primary',
  size: 'default',
  fullWidth: false,
  showLabel: false,
};

ToggleUnreadButton.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool.isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export default ToggleUnreadButton;
